import React from 'react';

export interface FileContextInterface {
  files: File[];
  urls: string[];
  onChangeFile: (event: React.FormEvent<HTMLInputElement>) => void;
  deleteFile: (file: File) => void;
}

export type OnFileChange = (event: React.FormEvent<HTMLInputElement>) => void;
export const FileContext = React.createContext<FileContextInterface>({
  files: [],
  urls: [],
  onChangeFile: () => {},
  deleteFile: () => {},
});
